import MggpPlayer from 'mggp-player';
import getTrackLang from './lib/getTrackLang.js';

export default MggpPluginAudio;

MggpPluginAudio.prototype = Object.create(MggpPlayer.Plugin.prototype);
MggpPluginAudio.prototype.constructor = MggpPluginAudio;

MggpPluginAudio.events = {
  /**
   * @name MggpPluginAudio#events.REQUIRE_SUBTITLES
   * @see requireSubtitles
   */
  REQUIRE_SUBTITLES: 'AUDIO:REQUIRE_SUBTITLES',
};

/**
 * @class MggpPluginAudio
 */
function MggpPluginAudio() {
  MggpPlayer.Plugin.apply(this, arguments);

  var self = this;

  var _player = self.player;
  var _videoInfo = null;
  var _availableAudioTracks = [];
  var _default = 0;
  var _stopped = false;
  var _started = false;

  this.dispose = function () {
    self.log('MggpPluginAudio.dispose()');
    tooggleEvents(false);

    _player = null;
    _videoInfo = null;
    _availableAudioTracks = null;
  };

  var onPlayerStop = function () {
    self.log('MggpPluginAudio.onPlayerStop()');
    _stopped = true;
    _started = false;

    _player.on('property:videoInfo', onVideoInfoChange);

    _videoInfo = null;
    _availableAudioTracks = [];
  };

  var onPlayerStateChange = function(pEvent) {
    if (!_started && pEvent.data === 1) _started = true;
  };

  /**
   * Watch on changing current audio track, due to it is possible change not only from this plugin
   * back-resolve track by id (yet again),
   * check is ARS is applicable by content type
   * then emit REQUIRE_SUBTITLES for any track, with or without ARS.
   *
   * @param {MggPlayerEvent} event
   * @emits MggpPluginAudio~REQUIRE_SUBTITLES
   */
  function onChangeAudioTrack(event) {
    const {
      data: trackId,
    } = event;
    const tracks = _player.get('audioTrackList');
    const track = tracks.find(({ id }) => id === trackId);
    const videoInfo = _player.get('videoInfo');
    /**
     * I have no idea, why we should limit only for such content type.
     * Just move here from subtitles plugin.
     *
     * Times to times there are no video info, why?
     */
    const isApplicable = videoInfo && [
      'vod', 'm_ch_vod', 'tv_dvr_vod', 'tv_linear_vod',
    ].includes(videoInfo.content_type);

    if (isApplicable && track) {
      // this onChangeAudioTrack could be called straight from onVideoInfoChange
      // but at that moment onVideoInfoChane in mggp-plugin-subtitles hadn't called yet (because event emitter didn't process it yet)
      // so emit REQUIRE_SUBTITLES event on the next tick of the event loop
      window.setTimeout(() => {
        /**
       * @event MggpPluginAudio~REQUIRE_SUBTITLES
       * @type {object}
       * @property {AudioTrack.require_subtitles} require
       * @property {AudioTrack.lang_iso_639_1} lang
       */
        _player.emit(MggpPluginAudio.events.REQUIRE_SUBTITLES, {
          require: track.require_subtitles,
          lang: getTrackLang(track),
        });
      }, 0);
    }
  }

  var onChangePlaylistItem = function (event) {
    onChangeAudioTrack({ data: _player.get('audioTrack') });
  };

  var onChangeAudioTrackList = function (event) {
    if (event.data !== _availableAudioTracks) {
      _availableAudioTracks = event.data || [];
    }
  };

  var onVideoInfoChange = function (event) {
    self.log('MggpPluginAudio.onVideoInfoChange()');
    _videoInfo = event.data || {};
    _default = 0;
    _availableAudioTracks = _videoInfo['audio_tracks'] || [];
    _player.set('audioTrackList', _availableAudioTracks);

    if (_stopped) {
      _stopped = false;
      tooggleEvents(true);
    }

    if (!_started) {
      var track = getCurrentTrack();
      if (track) {
        _player.set('audioTrack', track.id);
      } else {
        // if we cannot find the corresponding track in the stream, switch to the first track in the tracks list
        // https://jira.x2sy.com/browse/MHP-1446?focusedCommentId=1247646&page=com.atlassian.jira.plugin.system.issuetabpanels:comment-tabpanel#comment-1247646
        if (_availableAudioTracks.length) {
          onAudioTrackNeedChange({ data: _availableAudioTracks[0].id });
          // _player.set('audioTrack', _availableAudioTracks[0].id); // MHP-494
        }
      }
    }
  };

  var onSrcChange = function (event) {
    self.log('MggpPluginAudio.onSrcChange(' + event.data + ')');

    var options = _player.get('vendorOptions');

    if (!options.hasOwnProperty('defaultAudioTrack')) {
      options.defaultAudioTrack = _default;
    }
    _player.off('property:src', onSrcChange);
  };

  var changeByName = function (pName) {
    self.log('MggpPluginAudio.changeByName(' + pName + ')');
    var track = findAudioTrackByCondition('lang', pName);
    if (track) {
      onAudioTrackNeedChange({ data: track.id });
    } else {
      onAudioTrackNeedChange({ data: _default });
    }
  };

  var onQualityNeedChange = function () {
    self.log('MggpPluginAudio.onQualityNeedChange()');
    _player.on('property:src', onSrcChange);
  };

  var onAudioTrackNeedChange = function (event) {
    self.log('MggpPluginAudio.onAudioTrackNeedChange(' + event.data + ')');
    if (typeof event.data === 'string') {
      changeByName(event.data);
      return;
    }

    var neededId = parseInt(event.data) || 0;
    var neededTrack = getAudioTrackById(neededId);
    var currentTrack = getCurrentTrack();

    if (_player.config.deviceType !== 'tv' && currentTrack && neededId === currentTrack.id && _player.get('position') > 0) {
      loadDefault();
      return;
    }
    //если api не найдет дорожку с нужным языком, то вернет ключ /a == 0
    //соответсвено, текущий трек может не быть найден в списке доступных
    if ((!currentTrack || neededId !== currentTrack.id) && neededTrack) {
      _default = neededId;
      var options = _player.get('vendorOptions') || {};
      options.startSeconds = options.startSeconds || _player.get('position');

      var src = _player.get('src') || _videoInfo.src;
      var newSrc = modifysrc(src, neededTrack[getIndexOrIdPropName()]);
      _player.load(newSrc, _player.get('videoInfo'), options);

      _player.set('audioTrack', neededId);
      return;
    }

    _player.set('audioTrack', currentTrack ? currentTrack.id : getCurrentAudioIndexOrId()); //MHP-1743
    loadDefault(); // if not found
  };

  var getIndexOrIdPropName = function () {
    if (!_videoInfo) return 'index';
    var drmType = _videoInfo['drm_type'];
    if (!drmType && _videoInfo['is_wvdrm'] && _player.utils.getExtension( _videoInfo['src']) === 'wvm') {
      drmType = 'widevine';
    }

    return drmType === 'widevine' ? 'id' : 'index';
  };

  var getCurrentTrack = function () {
    return findAudioTrackByCondition(getIndexOrIdPropName(), getCurrentAudioIndexOrId());
  };

  var loadDefault = function () {
    self.log('MggpPluginAudio.loadDefault()');
    _player.load(
      _player.get('src'),
      _player.get('videoInfo'),
      _player.get('vendorOptions')
    );
  };

  var getCurrentAudioIndexOrId = function () {
    var result = 0;
    var i;
    var src = _player.get('src') || (_videoInfo ? _videoInfo.src : null);
    if (src && src.indexOf('/a/') !== -1) {
      var splits = src.split('/');
      for (i = 0; i < splits.length; i++) {
        if (splits[i] === 'a' && splits[i + 1]) {
          result = parseInt(splits[i + 1]);
          break;
        }
      }
    } else if (_player.get('audioTrackList')) {
      var tracks = _player.get('audioTrackList'); // Из-за перебивок не стоит работать с локальной копией
      for (i = 0; i < tracks.length; ++i) {
        if (tracks[i].is_active) {
          result = tracks[i].index;
          break;
        }
      }
    }

    return result;
  };

  var modifysrc = function (pUrl, pIndexOrId) {
    if (pUrl && pUrl.indexOf('/a/') !== -1) {
      return pUrl.replace('/a/' + getCurrentAudioIndexOrId(), '/a/' + pIndexOrId);
    }

    self.log('MggpPluginAudio.loadDefault(' + pUrl + ')');
    return pUrl;
  };

  var tooggleEvents = function (pOn) {
    self.log('MggpPluginAudio.tooggleEvents(' + pOn + ')');

    if (pOn) {
      _player.on('property:audioTrack', onChangeAudioTrack);
      _player.on('property:playlist:item', onChangePlaylistItem);
      _player.on('property:audioTrackList', onChangeAudioTrackList);
      _player.on('property:videoInfo', onVideoInfoChange);
      _player.on('property:state', onPlayerStateChange);
      _player.on('player:audioTackNeedChange', onAudioTrackNeedChange); // audioTackNeedChange -> audioTrackNeedChange
      _player.on('player:qualityNeedChange', onQualityNeedChange);
      _player.on('player:stop', onPlayerStop);
    } else {
      _player.off('property:audioTrack', onChangeAudioTrack);
      _player.off('property:playlist:item', onChangePlaylistItem);
      _player.off('property:audioTrackList', onChangeAudioTrackList);
      _player.off('property:videoInfo:', onVideoInfoChange);
      _player.off('player:qualityNeedChange', onQualityNeedChange);
      _player.off('player:audioTackNeedChange', onAudioTrackNeedChange); // audioTackNeedChange -> audioTrackNeedChange
      _player.off('player:stop', onPlayerStop);
    }
  };

  tooggleEvents(true);

  var findAudioTrackByCondition = function (propName, value) {
    var result = null;
    var tracks = _player.get('audioTrackList'); // Из-за перебивок не стоит работать с локальной копией
    if (tracks && tracks.length > 0) {
      for (var i = 0, l = tracks.length; i < l; ++i) {
        var track = tracks[i];
        if (track[propName] === value) {
          result = track;
          break;
        }
      }
    }
    return result;
  };

  var getAudioTrackById = function (id) {
    return findAudioTrackByCondition('id', id);
  };
}
